let currentSessionId = null;
let currentSessionLocation = null;
let currentSessionStartedAt = null;

function randomString(len = 16) {
  // Prefer cryptographically-strong randomness when available (web).
  try {
    const cryptoObj = typeof crypto !== 'undefined' ? crypto : null;
    if (cryptoObj?.getRandomValues) {
      const bytes = new Uint8Array(len);
      cryptoObj.getRandomValues(bytes);
      // base36-ish: map bytes to [0-35]
      let out = '';
      for (let i = 0; i < bytes.length; i += 1) {
        out += (bytes[i] % 36).toString(36);
      }
      return out;
    }
  } catch (_) {
    // fall back
  }

  // Fallback (React Native / older browsers): non-crypto random.
  let out = '';
  while (out.length < len) {
    out += Math.random().toString(36).slice(2);
  }
  return out.slice(0, len);
}

function buildSessionId({ location }) {
  const ts = Date.now(); // ms since epoch
  const loc = (location || 'unknown').toString().toLowerCase();
  return `mv_${loc}_${ts.toString(36)}_${randomString(12)}`;
}

/**
 * Starts (or reuses) the current "metaverse session".
 * A new session is created only when the effective metaverse `location` changes.
 *
 * @returns {string|null} The current session id (or null if excluded).
 */
export function startMetaverseSession({ location, excluded = false } = {}) {
  if (excluded || !location) {
    currentSessionId = null;
    currentSessionLocation = null;
    currentSessionStartedAt = null;
    return null;
  }

  const loc = String(location);
  if (currentSessionId && currentSessionLocation === loc) {
    return currentSessionId;
  }

  currentSessionLocation = loc;
  currentSessionStartedAt = Date.now();
  currentSessionId = buildSessionId({ location: loc });
  return currentSessionId;
}

export function getMetaverseSessionId() {
  return currentSessionId;
}

export function getMetaverseSessionInfo() {
  return {
    sessionId: currentSessionId,
    location: currentSessionLocation,
    startedAt: currentSessionStartedAt,
  };
}

export function clearMetaverseSession() {
  currentSessionId = null;
  currentSessionLocation = null;
  currentSessionStartedAt = null;
}

